<template>
  <!-- TODO:使用实例 <Upload v-model="form.businessLicense" :limit="1" @change="uploadChange" /> -->
  <div class="upload">
    <ul class="upload-list">
      <li v-for="(tem, index) in [...fileList]" :key="index" class="upload-item">
        <img :src="imagList[tem]" alt="">
        <div class="operation">
          <span @click="handlePictureCardPreview(imagList[tem])">
            <i class="el-icon-zoom-in" />
          </span>
          <span v-if="!disabled" @click="handleRemove(index)">
            <i class="el-icon-delete" />
          </span>
        </div>
      </li>
    </ul>
    <el-upload v-show="uploadShow" ref="upload" :http-request="fnUploadRequest"
               :on-success="handleSuccess"
               :before-upload="beforeUpload" v-bind="$attrs" :show-file-list="false"
               :accept="accept" class="avatar-uploader"
               action="">
      <el-progress v-if="false" :percentage="100" type="circle"
                   status="success" />
      <div v-else class="avatar-uploader-icon">
        <p>
          <i class="el-icon-plus " />
        </p>
        <p>{{ placeholder }}</p>
      </div>

    </el-upload>

    <el-dialog :visible.sync="dialogVisible" append-to-body>
      <img :src="dialogImageUrl" width="100%" alt="">
    </el-dialog>
  </div>
</template>

<script>
// import { compress } from '@/assets/js/common'
import $upload from '@/assets/js/enterprise/upload'
export default {
  model: {
    prop: 'fileList',
    event: 'input'
  },
  props: {
    fileList: {
      type: [Array, String],
      default: () => []
    },
    limit: {
      type: Number,
      default: 2
    },
    disabled: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    size: {
      type: Object,
      default: () => {
        return {
          size: 2 * 1024 * 1024,
          tips: '上传图片大小不能超过2MB!'
        }
      }
    },
    accept: {
      type: String,
      default: '.png,.PNG,.jpg,.jpeg,.JPG,.JPEG'
    }
  },
  data() {
    return {
      dialogImageUrl: '',
      dialogVisible: false,
      imagList: {}
    }
  },
  computed: {
    uploadShow() {
      if (this.disabled) {
        return false
      } else {
        return this.fileList.length < this.limit
      }
    }

  },
  watch: {
    fileList: {
      handler(newVal) {
        [...newVal].forEach((item) => {
          $upload('enterpriseImage', item, (res) => {
            this.$set(this.imagList, item, res)
          }, 1)
        })
        this.$emit('change', this.fileList)
      }
    },
    deep: true
  },

  methods: {
    /**
     * @description [fnUploadRequest 覆盖默认的上传行为，实现自定义上传]
     * @param    {object}   option [上传选项]
     * @return   {null}   [没有返回]
     */
    async fnUploadRequest(option) {
      return new Promise((resolve, reject) => {
        $upload(
          'enterpriseImage',
          option.file,
          (url) => {
            resolve(url)
          },
          ''
        )
      })
    },
    // 预览图片
    handlePictureCardPreview(url) {
      this.dialogImageUrl = url
      this.dialogVisible = true
    },
    // 上传验证
    beforeUpload(file) {
      let index = file.name.lastIndexOf('.')
      let extension = file.name.substr(index + 1)
      let extensionList = [
        'png',
        'jpg',
        'jpeg',
        'PNG',
        'JPG',
        'JPEG'
      ]
      const isLt2M = file.size < this.size.size
      if (!isLt2M) {
        this.$message.error(this.size.tips)
        return false
      } else if (extensionList.indexOf(extension) < 0) {
        this.$message({
          message: `当前文件格式不支持，仅支持${extensionList + ''}格式的文件`,
          type: 'error',
          center: true
        })
        return false
      }
      return true
    },
    // 上传成功后
    handleSuccess(response) {
      if (this.fileList.length < this.limit) {
        this.fileList.push(response)
      } else {
        this.$message.error(`图片最多上传${this.limit}张`)
      }
    },
    handleRemove(i) {
      this.fileList.splice(i, 1)
    }
  }
}
</script>

<style type="text/scss" lang="scss" scoped>
>>> .avatar-uploader {
  text-align: left;

  .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    overflow: hidden;
    width: 149px;
    height: 149px;
    line-height: 149px;

    display: flex;
    align-items: center;
    justify-content: center;
  }

  .el-upload:hover {
    border-color: #409eff;
  }
}

.avatar-uploader-icon {
  color: #8c939d;
  text-align: center;

  i {
    font-size: 28px;
  }

  p {
    line-height: 1.5;
  }
}

.upload {
  display: flex;
  align-items: flex-start;

  // .upload-list + .avatar-uploader {
  //   margin-right: 10px;
  // }

  .upload-list {
    display: flex;
    list-style: none;
    padding: 0;
    margin: 0;

    .upload-item {
      margin-right: 10px;
    }

    .upload-item {
      width: 149px;
      height: 149px;
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      position: relative;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .operation {
      position: absolute;
      width: 100%;
      height: 100%;
      left: 0;
      top: 0;
      text-align: center;
      color: #fff;
      opacity: 0;
      font-size: 20px;
      background-color: rgba(0, 0, 0, 0.5);
      transition: opacity 0.3s;

      display: flex;
      align-items: center;
      justify-content: center;

      &:hover {
        opacity: 1;
      }

      span {
        display: inline-block;
        padding: 10px;
        cursor: pointer;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/upload/index.vue